import { NAME } from "./constants";

export const SET_ADMINS_LOADING = `${NAME}/SET_ADMINS_LOADING`;

export const SET_ADMINS = `${NAME}/SET_ADMINS`;